function u(i, e, t) {
  e.center !== t.center && i.setLatLng(e.center), e.radius != null && e.radius !== t.radius && i.setRadius(e.radius);
}
export {
  u as updateCircle
};
